import React, { Suspense, lazy, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Redirect, Switch, Route, useRouteMatch } from "react-router-dom";
import {
  fetchSettings,
  fetchBusinessSettings,
} from "./modules/Settings/_redux/settings/settingsActions";
import { fetchProfile } from "./modules/Settings/_redux/profile/profileActions";
import { LayoutSplashScreen } from "../_metronic/layout";
import axios from "axios";
import { LoadingDialog } from "../_metronic/_partials/controls";
import Swal from "sweetalert2";
import { hasAdminAccess } from "./utils/permissions";

const CoursePage = lazy(() => import("./modules/Course/pages/CoursePage"));
const SettingsPage = lazy(() => import("./modules/Settings/SettingsPage"));
const UploadPage = lazy(() => import("./pages/UploadPage"));
const EnrolmentsPage = lazy(
  () => import("./modules/Enrolments/pages/enrolments/EnrolmentsPage"),
);
const SubscriptionsPage = lazy(
  () => import("./modules/Subscriptions/pages/subscriptions/SubcriptionsPage"),
);
const StudentsPage = lazy(
  () => import("./modules/Students/pages/students/StudentsPage"),
);
const CohortsPage = lazy(
  () => import("./modules/Cohort/pages/cohorts/ChohortsPage"),
);
const PersonaInformation = lazy(
  () => import("./modules/Settings/PersonaInformation"),
);
const SingleLoginPage = lazy(
  () => import("./modules/SingleLogin/pages/SingleLogin"),
);
const YouthEmailsPage = lazy(
  () => import("./modules/YouthEmails/pages/YouthEmailsPage"),
);
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const InstalmentPaymentsPage = lazy(
  () => import("./modules/InstalmentPayments/pages/InstalmentPaymentsPage"),
);
// const AuditLogsPage = lazy(() =>
//   import("./modules/AuditLogs/AuditLogsPage")
// );
const OnboardingPage = lazy(
  () => import("./modules/Onboarding/OnboardingPage"),
);

export function BasePage() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (isAuthorized) {
      dispatch(fetchBusinessSettings());
    }
  }, [dispatch, isAuthorized]);
  return (
    <Switch>
      <Redirect exact from="/" to="/manage/students" />
      {/* Admin access is gated in Routes.js (above the Layout), so any user who
          reaches BasePage is already an authenticated admin. */}
      <Route path="/manage" component={AdminPage} />
      <Route path="/zoom1" component={Zoom} />
      <Route path="/zoom2" component={Zoom2} />
      <Redirect to="/manage/students" />
    </Switch>
  );
}
function AdminPage() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual,
  );
  const { user } = useSelector(
    (state) => ({
      user: state.auth.user,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSettings());
    dispatch(fetchProfile());
  }, [dispatch]);
  const { path } = useRouteMatch();
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      {!isAuthorized ? (
        <Redirect to="/auth/login" />
      ) : (
        <Switch>
          <Redirect exact from={path} to={`${path}/students`} />
          <Route path={`${path}/dashboard`} component={DashboardPage} />
          <Route path={`${path}/enrolments`} component={EnrolmentsPage} />
          <Route path={`${path}/students`} component={StudentsPage} />
          <Route path={`${path}/onboarding`} component={OnboardingPage} />
          <Route path={`${path}/subscriptions`} component={SubscriptionsPage} />
          {/* <Route
            path={`${path}/instalment-payments`}
            component={InstalmentPaymentsPage}
          /> */}
          <Route path={`${path}/cohorts`} component={CohortsPage} />
          <Route path={`${path}/profile`} component={PersonaInformation} />
          <Route path={`${path}/upload`} component={UploadPage} />
          {/* {isOwnerUser(user) && (
            <Route path={`${path}/audit-logs`} component={AuditLogsPage} />
          )} */}
          {hasAdminAccess(user) ? (
            <Route path={`${path}/settings`} component={SettingsPage} />
          ) : (
            <Redirect from={`${path}/settings`} to={`${path}/students`} />
          )}
          <Route path={`${path}/singlelogin`} component={SingleLoginPage} />
          <Route path={`${path}/youth-emails`} component={YouthEmailsPage} />
          <Route path={`${path}/courses`} component={CoursePage} />
          <Redirect to="/error/error-v1" />
        </Switch>
      )}
    </Suspense>
  );
}

const Zoom = () => {
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "/zoom_link")
      .then((res) =>
        res.ZoomLink
          ? (window.location.href = res.ZoomLink)
          : Swal.fire({
              icon: "error",
              html: "No zoom link set",
            }),
      )
      .catch((err) =>
        Swal.fire({
          icon: "error",
          html: err.message,
        }),
      );
  }, []);
  return <LoadingDialog />;
};
const Zoom2 = () => {
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_URL + "/zoom_link2")
      .then((res) =>
        res.ZoomLink2
          ? (window.location.href = res.ZoomLink2)
          : Swal.fire({
              icon: "error",
              html: "No zoom link set",
            }),
      )
      .catch((err) =>
        Swal.fire({
          icon: "error",
          html: err.message,
        }),
      );
  }, []);
  return <LoadingDialog />;
};
